/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// ===============================
// Cart Offers
// ===============================
//
// 1. Every order ships with a special gift. The team picks the item when
//    packing, so the cart only tells the customer a gift is included.
// 2. Prepaid orders of Rs 1,500 or more get 15% off with code PREPAID15,
//    plus a free Pyrite Bracelet that the team packs for every order that
//    used the code.
//
// Customers choose COD or prepaid at checkout, so the cart can only
// announce offer 2. Hiding COD when PREPAID15 is applied is a payment rule
// in the Shopify admin, not something this file can do.

const OLD_GIFT_VARIANT = 42954443980896;
const PREPAID_CODE = "PREPAID15";
const PREPAID_MINIMUM = 150000; // paise; the same minimum the code itself has

(function () {

    let subtotal = null;

    const offerBoxes = new Set();

    async function getCart() {

        const res = await fetch("/cart.js");

        return await res.json();

    }

    // -----------------------
    // Old complimentary bracelet
    // -----------------------
    // The Pyrite Bracelet used to be added to every cart as a Rs 0 line.
    // Carts that still hold it (or anyone adding the Rs 0 product by hand)
    // get the line removed. Returns true once the line is really gone.

    async function removeOldGift(cart) {

        const line = cart.items.find(i => i.variant_id === OLD_GIFT_VARIANT);

        if (!line) return false;

        const res = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: line.key,
                quantity: 0
            })
        });

        if (!res.ok) return false;

        const updated = await res.json();

        return !updated.items.some(i => i.variant_id === OLD_GIFT_VARIANT);

    }

    let syncing = false;

    async function syncCart() {

        if (syncing) return;

        syncing = true;

        try {

            const cart = await getCart();

            if (await removeOldGift(cart)) {

                // The theme's cart store doesn't see changes made here, so
                // redraw once. Nothing adds the line back, so this can't loop.
                window.location.reload();
                return;

            }

            setSubtotal(cart.items_subtotal_price);

        }

        catch (e) {

            console.error("Cart offers error:", e);

        }

        finally {

            syncing = false;

        }

    }

    function onCartEvent(e) {

        const cart = e.detail && e.detail.cart;

        if (cart && Array.isArray(cart.items)) {

            setSubtotal(cart.items_subtotal_price);

            if (cart.items.some(i => i.variant_id === OLD_GIFT_VARIANT)) syncCart();

            return;

        }

        syncCart();

    }

    // -----------------------
    // Offer box shown in the cart drawer and on the cart page
    // -----------------------

    function setSubtotal(value) {

        subtotal = value;

        offerBoxes.forEach(box => box.render());

    }

    function formatRupees(paise) {

        return "₹" + Math.ceil(paise / 100).toLocaleString("en-IN");

    }

    class CartOffers extends HTMLElement {

        connectedCallback() {

            offerBoxes.add(this);

            this.render();

        }

        disconnectedCallback() {

            offerBoxes.delete(this);

        }

        render() {

            let prepaid = "";

            if (subtotal !== null && subtotal >= PREPAID_MINIMUM) {

                prepaid = `💳 Pay online with code <button type="button" class="cart-offers__code" title="Copy code">${PREPAID_CODE}</button> for <strong>extra 15% OFF + a FREE Pyrite Bracelet</strong>`;

            } else if (subtotal !== null) {

                prepaid = `💳 Add <strong>${formatRupees(PREPAID_MINIMUM - subtotal)}</strong> more and pay online for <strong>extra 15% OFF + a FREE Pyrite Bracelet</strong>`;

            }

            this.innerHTML =
                `<p class="cart-offers__row">🎁 <strong>A special gift</strong> is included with your order</p>` +
                (prepaid ? `<p class="cart-offers__row">${prepaid}</p>` : "");

        }

    }

    customElements.define("cart-offers", CartOffers);

    // The theme clones #template-cart whenever the cart goes from empty to
    // full, so the box goes into the templates as well as the carts already
    // on the page.

    function addOfferBoxes(root) {

        root.querySelectorAll("cart-full").forEach(cartFull => {

            if (cartFull.querySelector("cart-offers")) return;

            const box = document.createElement("cart-offers");

            const bar = cartFull.querySelector("free-shipping-bar");

            if (bar) {
                bar.after(box);
            } else {
                cartFull.prepend(box);
            }

        });

    }

    const style = document.createElement("style");

    style.textContent = `
        cart-offers { display: block; margin: 0 0 12px; }
        free-shipping-bar + cart-offers { margin-top: -12px; }
        .cart--draw cart-offers { padding: 0 18px; }
        @media (min-width: 35em) { .cart--draw cart-offers { padding: 0 42px; } }
        .cart-offers__row { margin: 6px 0 0; padding: 8px 12px; border-radius: 8px; background: rgba(25, 135, 84, 0.08); color: #14532d; font-size: 13px; line-height: 1.45; }
        .cart-offers__code { font: inherit; font-weight: 700; padding: 0 6px; border: 1px dashed currentColor; border-radius: 4px; background: #fff; color: inherit; cursor: pointer; }
    `;

    document.head.appendChild(style);

    document.querySelectorAll("template#template-cart").forEach(t => addOfferBoxes(t.content));

    addOfferBoxes(document);

    document.addEventListener("click", function (e) {

        const code = e.target.closest(".cart-offers__code");

        // Clipboard can be missing or blocked; the code is still on screen to type.
        if (!code || !navigator.clipboard) return;

        navigator.clipboard.writeText(PREPAID_CODE).then(() => {

            code.textContent = "Copied ✓";

            setTimeout(() => { code.textContent = PREPAID_CODE; }, 1500);

        }).catch(() => {});

    });

    // -----------------------
    // Cart sync
    // -----------------------
    // "on:cart:loaded" is fired by the theme's cart store after every add,
    // change or remove, with the new cart in e.detail.cart.

    syncCart();

    ["on:cart:loaded", "cart:refresh", "cart:updated", "cart:update", "cart:change"].forEach(eventName => {

        document.addEventListener(eventName, onCartEvent);

    });

    // -----------------------
    // Shiprocket Checkout Protection
    // -----------------------

    let checkoutRunning = false;

    // Guard the Shiprocket call so a missing/late-loaded script never
    // leaves the customer stuck with no way to check out at all -
    // fall back to Shopify's own checkout instead.

    function callBuyCart(e) {

        if (
            window.shiprocketCheckoutEvents &&
            typeof shiprocketCheckoutEvents.buyCart === "function"
        ) {

            shiprocketCheckoutEvents.buyCart(e);

        } else {

            window.location.href = "/checkout";

        }

    }

    document.addEventListener("click", async function (e) {

        const btn = e.target.closest(`
            .sr-headless-checkout,
            [name="checkout"],
            button[name="checkout"],
            .cart__checkout,
            .drawer__checkout,
            .drawer-checkout,
            .mini-cart__checkout,
            .sticky-checkout,
            .checkout-btn,
            .buy-now
       `);

        if (!btn || checkoutRunning) return;

        checkoutRunning = true;

        e.preventDefault();
        e.stopImmediatePropagation();

        try {

            // Never let the old Rs 0 bracelet line reach checkout
            await removeOldGift(await getCart());

        } catch (err) {

            console.error("Checkout cleanup error:", err);

        } finally {

            // Never block checkout because of the cleanup
            callBuyCart(e);

            // Small delay prevents accidental double-clicks
            setTimeout(() => {

               checkoutRunning = false;

            }, 500);

        }

    }, true);

})();
